export const $blue = '#3068f4'
export const $indigo = '#6610f2'
export const $purple = '#6f42c1'
export const $pink = '#e83e8c'
export const $red = '#d32c3f'
export const $orange = '#fd7e14'
export const $yellow = '#ffc107'
export const $green = '#1F9B4A'
export const $teal = '#20c997'
export const $cyan = '#17a2b8'

export const $white = '#ffffff'
export const $gray_100 = '#f5f6f8'
export const $gray_200 = '#efefef'
export const $gray_300 = '#e5e5e5'
export const $gray_400 = '#dcdcdc'
export const $gray_500 = '#96a1a9'
export const $gray_600 = '#78909c'
export const $gray_700 = '#505050'
export const $gray_800 = '#444444'
export const $gray_900 = '#2d3035'
export const $black = '#000'

export const $primary = $blue
export const $secondary = $gray_600
export const $success = $green
export const $info = $cyan
export const $warning = $yellow
export const $danger = $red
export const $light = $gray_100
export const $dark = $gray_900

export const $grayTitle = '#4E5155'
export const $grayDescription = '#667283'

export default {
    primary: $primary,
    secondary: $secondary,
    success: $success,
    info: $info,
    warning: $warning,
    danger: $danger,
    light: $light,
    dark: $dark,
    grayTitle: $grayTitle,
    grayDescription: $grayDescription,
    icon: $gray_600,
    fadeIcon: 'rgba(150, 161, 169, 0.5)',
    inputIcon: 'rgba(45, 48, 53, 0.5)',
    gray1: $gray_100,
    gray3: $gray_300,
    sidebarItem: '#BCBCBC',
    inputBorder: 'rgba(24, 28, 33, 0.15)',
    keppel: '#2DB3AC',
    grayTitleOpacity: (opacity) => `rgba(78, 81, 85, ${opacity})`,
    iconOpacity: (opacity) => `rgba(120, 144, 156, ${opacity})`,
    darkOpacity: (opacity) => `rgba(45, 48, 53, ${opacity})`,
    shadow: 'rgba(0, 0, 0, 0.2)',
    activeTool: '#FFCA43',
    primaryOpacity: (opacity) => `rgba(48, 104, 244, ${opacity})`,
    statusBorder: 'rgba(176, 190, 197, 0.2)',
    helpTextOpacity: (opacity) => `rgba(66, 69, 74, ${opacity})`,
    pageBackground: '#F9F9F9',
}
